import { Avatar, SvgIcon } from '@mui/material';
import { StyledTooltip } from './StyledTooltip';

const ContactAvatar = ({ person, color, size, tooltipText, tooltipColor }) => {
	const personImgSrc = (() => {
		if (person.image.startsWith('data:') || person.image.startsWith('https:')) {
			return person.image;
		}
		return `data:image/jpeg;base64,${person.image}`;
	});
	return (
		<StyledTooltip text={tooltipText} color={tooltipColor}>
			{person.image ?
				<Avatar
					sx={{
						'@container course-info (min-width: 600px) and (max-width: 960px)': {
							height: '2.75rem',
							width: '2.75rem',
						},
						height: '4.375rem',
						width: '4.375rem'
					}}
					alt={person.fullName}
					src={personImgSrc()}
					variant='rounded'
				/>
				:
				<Avatar
					sx={{
						background: color,
						'@container course-info (min-width: 600px) and (max-width: 960px)': {
							height: '2.75rem',
							width: '2.75rem',
						},
						height: '4.375rem',
						width: '4.375rem'
					}}
					variant='rounded'
				>
					<SvgIcon sx={{ '@container course-info (min-width: 600px) and (max-width: 960px)': { width: `calc(${size} - 1rem)` }, width: `${size}`, height: 'auto' }}>
						<svg id='icon' xmlns='http://www.w3.org/2000/svg' viewBox='0 0 320 320'>
							<rect width='100%' fill='none' strokeWidth={0} />
							<path fill='#FFFFFF' strokeWidth={0}
								  d='M93.89,193.99h18.88c26.09,0,47.23,21.14,47.23,47.19,0,5.21-4.21,9.46-9.46,9.46H56.15c-5.24,0-9.46-4.22-9.46-9.46,0-26.05,21.14-47.19,47.19-47.19ZM103.35,114.68c12.14,0,23.37,6.48,29.44,17s6.07,23.47,0,33.99c-6.07,10.52-17.3,17-29.44,17s-23.37-6.48-29.44-17c-6.07-10.52-6.07-23.47,0-33.99s17.3-17,29.44-17ZM103.35,92.02c0-12.5,10.16-22.66,22.66-22.66h124.63c12.5,0,22.66,10.16,22.66,22.66v101.97c0,12.5-10.16,22.66-22.66,22.66h-84.7c-4.18-9.03-10.59-16.82-18.55-22.66h35.27v-11.33c0-6.27,5.06-11.33,11.33-11.33h22.66c6.27,0,11.33,5.06,11.33,11.33v11.33h22.66v-101.97h-124.63v17.38c-6.65-3.85-14.41-6.05-22.66-6.05v-11.33Z' />
						</svg>
					</SvgIcon>
				</Avatar>}
		</StyledTooltip>
	);
};

export { ContactAvatar };